import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1 pb-2" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _c(
        VCard,
        { staticClass: "audiencias" },
        [
          _c(VCardText, [
            _c(
              "div",
              { staticClass: "form-row row--dense", attrs: { cols: "12" } },
              [
                _c(VCol, { attrs: { cols: "12" } }, [
                  _c(
                    "div",
                    { staticClass: "min-w-0 w-full" },
                    [
                      _c(
                        "actions-component",
                        { attrs: { class_table: _vm.getClassTable } },
                        [
                          _c(
                            "template",
                            { slot: "actions" },
                            [
                              _vm.is_admin
                                ? _c(
                                    VBtn,
                                    {
                                      staticClass: "ml-1 primary text-white",
                                      attrs: { dense: "", outlined: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openModalReport()
                                        },
                                      },
                                    },
                                    [
                                      _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("mdi-plus"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "report_management.report_management_page.actionsButtons.new"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                VBtn,
                                {
                                  staticClass: "ml-1 btn-inca-secondary",
                                  attrs: { dense: "", outlined: "" },
                                  on: { click: _vm.onShowFilter },
                                },
                                [
                                  _vm.model.buttons.show_filter
                                    ? _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v(" mdi-filter-off-outline "),
                                      ])
                                    : _vm._e(),
                                  !_vm.model.buttons.show_filter
                                    ? _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("mdi-filter-outline"),
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("botones.boton_filtrar")) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c("dialog-confirmation-component", {
                        ref: _vm.model.modal_report_confirmation_delete.name,
                        attrs: {
                          title: _vm.$t("campaign.general.confirm"),
                          text: _vm.$t(
                            "report_management.modal_delete_report.message_confirmation"
                          ),
                          si_text: _vm.$t("campaign.general.confirm_yes"),
                        },
                        on: { onConfirm: _vm.deleteReport },
                      }),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { staticClass: "pt-0", class: _vm.getClassTable },
                            [
                              _c(
                                VCard,
                                [
                                  _c(VDataTable, {
                                    key: _vm.model.grid.key,
                                    staticClass: "table-inca",
                                    attrs: {
                                      headers: _vm.loadGridHeader,
                                      items: _vm.model.grid.data,
                                      "hide-default-footer": true,
                                      page: _vm.model.grid.pagination.current,
                                      "sort-by": ["created_date"],
                                      "sort-desc": [true],
                                    },
                                    on: {
                                      "update:page": function ($event) {
                                        return _vm.$set(
                                          _vm.model.grid.pagination,
                                          "current",
                                          $event
                                        )
                                      },
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item.created_date",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.created_date
                                                    ? _vm.utils.formatDateTime(
                                                        item.created_date
                                                      )
                                                    : ""
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.updated_date",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.updated_date
                                                    ? _vm.utils.formatDateTime(
                                                        item.updated_date
                                                      )
                                                    : ""
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.view",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              VTooltip,
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function (ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            VBtn,
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openReport(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                "v-btn",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _c(VIcon, [
                                                                _vm._v(
                                                                  "mdi-eye"
                                                                ),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Ver reporte"),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.acciones",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              VMenu,
                                              {
                                                attrs: { bottom: "", left: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function (ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            VBtn,
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                },
                                                                "v-btn",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _c(VIcon, [
                                                                _vm._v(
                                                                  "mdi-dots-vertical"
                                                                ),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c(
                                                  VList,
                                                  [
                                                    _c(
                                                      VListItem,
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openModalReport(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          VListItemIcon,
                                                          [
                                                            _c(VIcon, [
                                                              _vm._v(
                                                                "mdi-pencil"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          VListItemContent,
                                                          [
                                                            _c(
                                                              VListItemTitle,
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "report_management.report_management_page.grid.actions.edit"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      VListItem,
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openModalConfirmationDelete(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          VListItemIcon,
                                                          [
                                                            _c(VIcon, [
                                                              _vm._v(
                                                                "mdi-delete"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          VListItemContent,
                                                          [
                                                            _c(
                                                              VListItemTitle,
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "report_management.report_management_page.grid.actions.delete"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _c("pagination-vue", {
                                attrs: {
                                  pagination: _vm.model.grid.pagination,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.model.buttons.show_filter
                            ? _c(
                                "common-filter-grid",
                                [
                                  _c("common-input", {
                                    attrs: {
                                      label: _vm.$t(
                                        "report_management.report_management_page.grid.filter.title"
                                      ),
                                      "col-size": 12,
                                    },
                                    model: {
                                      value: _vm.model.filter.title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.model.filter, "title", $$v)
                                      },
                                      expression: "model.filter.title",
                                    },
                                  }),
                                  _c("common-input", {
                                    attrs: {
                                      label: _vm.$t(
                                        "report_management.report_management_page.grid.filter.description"
                                      ),
                                      "col-size": 12,
                                    },
                                    model: {
                                      value: _vm.model.filter.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model.filter,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "model.filter.description",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mb-2 col-md-12 text-right",
                                    },
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          staticClass: "default mr-1",
                                          attrs: { outlined: "outlined" },
                                          on: { click: _vm.onCleanFilter },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("btns.clean")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        VBtn,
                                        {
                                          staticClass: "primary",
                                          on: { click: _vm.onSearch },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("btns.search")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("modal-report", {
        ref: _vm.model.modal_name,
        on: { updated: _vm.loadGridData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }